import * as React from "react";
// import ActiveOrderCard from "./components/active_order";
import AccountDetailsCard from "./components/account_details";
import BillingDataCard from "./components/billing_data";

const DetailCards: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* <ActiveOrderCard /> */}
      <AccountDetailsCard />
      <BillingDataCard />
    </div>
  );
};

export default DetailCards;
